import { render, staticRenderFns } from "./ProfileEditPassword.vue?vue&type=template&id=543fa171&scoped=true"
import script from "./ProfileEditPassword.vue?vue&type=script&lang=js"
export * from "./ProfileEditPassword.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditPassword.vue?vue&type=style&index=0&id=543fa171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543fa171",
  null
  
)

export default component.exports